import { JSX, useEffect } from "react";
import { useSubscription } from "@apollo/client";
import { AgendaDocument, OnCreateAgendaDocumentByUserIdSubscription, OnCreateAgendaDocumentByUserIdSubscriptionVariables } from "../../../graphql/API";
import { onCreateAgendaDocumentByUserId } from "../queries";

const SubscriptionDocumentWrapper = ({ userId, onNewDocument, subscriptionKey, onError }: {
    userId: string;
    onNewDocument: (document: AgendaDocument) => void;
    subscriptionKey: number;
    onError?: () => void;
  }): JSX.Element | null => {
    // console.log('userId', userId)
    const { data, error } = useSubscription<
      OnCreateAgendaDocumentByUserIdSubscription, 
      OnCreateAgendaDocumentByUserIdSubscriptionVariables>(onCreateAgendaDocumentByUserId, {
        variables: { userId },
        skip: !userId,
    });
  
    useEffect(() => {
      if (data?.onCreateAgendaDocumentByUserId) {
        onNewDocument(data.onCreateAgendaDocumentByUserId as AgendaDocument);
      }
    }, [data]);
  
    useEffect(() => {
        if (error) {
          console.error("Subscription error");//:", error);
          onError?.();
        }
      }, [error]);
  
    return null;
  };
 export default SubscriptionDocumentWrapper  